// import { useState, useEffect } from "react";
// import { toast } from "react-toastify";
// import {
//   getSubscriptionPlansApi,
//   createSubscriptionPlanApi,
// } from "../../apis/subscriptionApi";

// export const useSubscriptionPlans = (search) => {
//   const [plans, setPlans] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const fetchPlans = async (silent = false) => {
//     if (!silent) setLoading(true);
//     setError(null);

//     let toastId = null;
//     if (!silent) {
//       toastId = toast.loading("Loading subscription plans...");
//     }

//     try {
//       const data = await getSubscriptionPlansApi(search);
//       setPlans(data || []);

//       if (toastId) {
//         toast.update(toastId, {
//           // render: "Subscription plans loaded",
//           type: "success",
//           isLoading: false,
//           autoClose: 1500,
//         });
//       }
//     } catch (err) {
//       const message =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to load subscription plans";

//       if (toastId) {
//         toast.update(toastId, {
//           render: message,
//           type: "error",
//           isLoading: false,
//         });
//       } else {
//         toast.error(message);
//       }

//       setError(message);
//       console.error(err);
//     } finally {
//       if (!silent) setLoading(false);
//     }
//   };

//   const addPlan = async (planData) => {
//     const toastId = toast.loading("Creating new subscription plan...");

//     try {
//       const res = await createSubscriptionPlanApi(planData);
//       const createdPlan = res?.data ?? res; // normalize API shape

//       setPlans((prev) => [createdPlan, ...prev]); // instant UI update

//       toast.update(toastId, {
//         render: "New plan created successfully!",
//         type: "success",
//         isLoading: false,
//         autoClose: 3000,
//       });

//       return createdPlan;
//     } catch (err) {
//       const message =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to create subscription plan";

//       toast.update(toastId, {
//         render: message,
//         type: "error",
//         isLoading: false,
//         autoClose: 5000,
//       });

//       setError(message);
//       throw err;
//     }
//   };

//   useEffect(() => {
//     fetchPlans(true);
//   }, [search]);

//   return { plans, loading, error, fetchPlans, addPlan };
// };

import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  getSubscriptionPlansApi,
  createSubscriptionPlanApi,
} from "../../apis/subscriptionApi";

export const useSubscriptionPlans = (search) => {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
  // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Subscription plan operation failed.",
    };
  };

  const fetchPlans = async (silent = false) => {
    if (!silent) setLoading(true);
    setError(null);

    let toastId = null;
    if (!silent) {
      toastId = toast.loading("Loading subscription plans...");
    }

    try {
      const data = await getSubscriptionPlansApi(search);
      setPlans(data?.data || data || []);

      if (toastId) {
        toast.update(toastId, {
          render: (
            <div>
              <strong>Plans Loaded</strong>
              <div>Subscription plans loaded successfully.</div>
            </div>
          ),
          type: "success",
          isLoading: false,
          autoClose: 1500,
        });
      }
    } catch (err) {
      const { title, issue } = extractError(err);

      if (toastId) {
        toast.update(toastId, {
          render: (
            <div>
              <strong>{title}</strong>
              <div>{issue}</div>
            </div>
          ),
          type: "error",
          isLoading: false,
        });
      } else {
        toast.error(
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        );
      }

      setError({ title, issue });
    } finally {
      if (!silent) setLoading(false);
    }
  };

  const addPlan = async (planData) => {
    const toastId = toast.loading("Creating subscription plan...");
    setError(null);

    try {
      const res = await createSubscriptionPlanApi(planData);
      const createdPlan = res?.data ?? res;

      setPlans((prev) => [createdPlan, ...prev]);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Plan Created</strong>
            <div>Subscription plan created successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      return createdPlan;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 5000,
      });

      setError({ title, issue });
      throw err;
    }
  };

  useEffect(() => {
    fetchPlans(true);
  }, [search]);

  return { plans, loading, error, fetchPlans, addPlan };
};